// extracted by mini-css-extract-plugin
module.exports = {"mCard":"Pd","image":"Qd","imageNoBackground":"Rd"};